import { ref } from 'vue'

// Earth's radius in meters
const EARTH_RADIUS = 6371000

export function useCoverageCalculation() {
  // Function to calculate coverage radius in meters based on satellite altitude
  function calculateCoverageRadiusMeters(altitudeKm) {
    if (typeof altitudeKm !== 'number' || altitudeKm <= 0) {
      return 0
    }

    const altitudeM = altitudeKm * 1000
    const h = EARTH_RADIUS + altitudeM
    
    // Using the Pythagorean theorem to calculate the radius of the coverage circle
    // The coverage radius is the distance from the point directly below the satellite
    // to the edge of the coverage area on Earth's surface
    const coverageRadius = Math.sqrt(h * h - EARTH_RADIUS * EARTH_RADIUS)
    
    return coverageRadius
  }

  const coverageCircleData = ref({
    visible: false,
    center: [0, 0],
    radius: 0,
    color: '#ff3b30',
    fillColor: '#ff3b30',
    fillOpacity: 0.1,
    weight: 1
  })

  function updateCoverageCircle(satellite) {
    if (satellite && typeof satellite.altitude === 'number') {
      const radius = calculateCoverageRadiusMeters(satellite.altitude)
      coverageCircleData.value = {
        visible: true,
        center: [satellite.lat, satellite.lng],
        radius,
        color: '#ff3b30',
        fillColor: '#ff3b30',
        fillOpacity: 0.1,
        weight: 1
      }
    } else {
      coverageCircleData.value.visible = false
    }
  }

  return {
    calculateCoverageRadiusMeters,
    coverageCircleData,
    updateCoverageCircle
  }
}